import {UI, type PartialOptions} from "../../stem-core/ui/UIBase";
import type {NodeAttributes} from "../../stem-core/ui/NodeAttributes";

interface BorderedLabelOptions {
    borderWidth?: number;
    borderColor?: string;
}

export class BorderedLabel extends UI.Primitive("span")<BorderedLabelOptions> {
    getDefaultOptions(): PartialOptions<BorderedLabel> {
        return {
            borderWidth: 1,
        }
    }

    extraNodeAttributes(attr: NodeAttributes) {
        const {borderWidth, borderColor} = this.options;
        attr.setStyle({
            padding: "1px 8px",
            paddingTop: 3,
            border: `${borderWidth}px solid ${borderColor || ""}`,
        });
    }
}
